module.exports = __webpack_public_path__ + "assets/img/174f9048b67c1808cd0f584326dbb500.svg";